import React from 'react'
import styled from '@emotion/styled'

import {Button} from '@vio/atlas/Button'
import {ButtonLink} from '@vio/atlas/ButtonLink'
import {Icon} from '@vio/atlas/Icon'
import mirror from '@vio/atlas/src/utils/mirror'
import {cssTheme} from '@vio/atlas/themes'

const ButtonWrapper = styled.div`
  display: inline-flex;
  gap: ${cssTheme.layout.spacing.s500};
`

const StyledBackButton = styled(Button)`
  ${mirror()}
`

interface Props {
  label: string
  onClick: () => void
  /** Show only the round chevron button, without the text link */
  hideText?: boolean
}

export const BackLink = ({label, onClick, hideText = false}: Props) => (
  <ButtonWrapper>
    <StyledBackButton
      variant="tertiary"
      isRounded
      size="md"
      iconStart={<Icon name="ChevronLeft" />}
      ariaLabel={label}
      onClick={onClick}
    />
    {!hideText && (
      <ButtonLink tabIndex={0} role="button" onClick={onClick}>
        {label}
      </ButtonLink>
    )}
  </ButtonWrapper>
)
